import { ComponentProps, forwardRef, ReactNode } from 'react'
import { cn } from '../utils'
import { Badge as InternalBadge } from '@bpinternal/ui-kit-next'
import { Color } from '~/types'

type Props = {
  children: ReactNode
  className?: string
  color?: Color
} & ComponentProps<typeof InternalBadge>

const variantMap = (color: Color, variant: ComponentProps<typeof InternalBadge>['variant']) => {
  return {
    default: `bg-${color}-500`,
    secondary: `bg-${color}-50 text-${color}-500`,
    destructive: `bg-${color}-50 text-${color}-500`,
    outline: `bg-${color}-50 text-${color}-500 border-${color}-400`,
  }[variant ?? 'default']
}

const getColorVariant = (color: Color, variant: ComponentProps<typeof InternalBadge>['variant']): string => {
  return variantMap(color, variant)
}

export const Badge = forwardRef<HTMLDivElement, Props>(({ children, className, color, variant, ...props }, ref) => {
  return (
    <InternalBadge
      ref={ref}
      className={cn(
        color && getColorVariant(color, variant),
        'rounded-sm px-1.5 shadow-none hover:shadow-none',
        className
      )}
      variant={variant}
      {...props}
    >
      {children}
    </InternalBadge>
  )
})

Badge.displayName = 'Badge'
